// extracted by mini-css-extract-plugin
export default {"header":"Header_header__JgEG2","imgWrapper":"Header_imgWrapper__E2osV","wrapper":"Header_wrapper__IUnnm"};